// Minimal SSE wrapper to keep EventSource handling consistent.
const supportsSse = () => typeof EventSource !== "undefined";

const subscribeSseEvents = (url, handlers = {}) => {
  if (!supportsSse()) {
    return null;
  }
  const source = new EventSource(url);
  let closed = false;
  const close = () => {
    if (closed) {
      return;
    }
    closed = true;
    source.close();
  };

  const onError =
    typeof handlers.onError === "function" ? handlers.onError : null;
  source.onerror = error => {
    if (onError) {
      onError(error);
    }
  };

  const onOpen = typeof handlers.onOpen === "function" ? handlers.onOpen : null;
  if (onOpen) {
    source.onopen = () => onOpen();
  }

  const events = handlers.events || {};
  Object.entries(events).forEach(([eventName, handler]) => {
    if (typeof handler === "function") {
      source.addEventListener(eventName, handler);
    }
  });

  return { close, source };
};

export { subscribeSseEvents, supportsSse };
